export default __webpack_public_path__ + "static/media/empty.0de4ace6.webp";